import { Link } from "react-router-dom";
import "./Sidebar.css";

function Sidebar({ rol }) {

  return (
    <nav className="sidebar">
      <ul>
        {rol === "Tutor" && (
          <>
            <li><Link to="/dashboard">Inicio</Link></li>
            <li><Link to="/registrar">Registrar</Link></li>
            <li><Link to="/tablas">Documento Agente</Link></li>
            <li><Link to="/ganancias">ID Streamer</Link></li>
            <li><Link to="/lideres">Lideres</Link></li>
            <li><Link to="/logout">Cerrar sesión</Link></li>
          </>
        )}
        {rol === "Lider" && (
          <>
            <li><Link to="/dashboard">Inicio</Link></li>
            <li><Link to="/registrar">Registrar</Link></li>
            <li><Link to="/tablas">Documento Lider</Link></li>
            <li><Link to="/ganancias">ID Streamer</Link></li>
            <li><Link to="/logout">Cerrar sesión</Link></li>
          </>
        )}
      </ul>
    </nav>
  );
}

export default Sidebar;
